import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import ServicesData from "../../sections/Services/ServiceData"; 
import "./ServicesList.css";

const ServicesList = () => {
  const { serviceName } = useParams(); // current service slug

  // Scroll to top whenever serviceName changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [serviceName]);

  return (
    <section className="services-list-section container">
      <h2 className="services-list-title">Explore Other Services</h2>
      <div className="services-list-grid">
        {ServicesData.filter(service => service.slug.toLowerCase() !== serviceName?.toLowerCase())
          .map((service, index) => (
            <Link
              key={index}
              to={`/services/${service.slug.toLowerCase()}`}
              className="service-card"
            >
              <img
                src={service.imageUrl}
                alt={service.title}
                className="service-card-img"
              />
              <h3>{service.title}</h3>
              <p>{service.description.substring(0, 90)}...</p>
            </Link>
          ))}
      </div>
    </section>
  );
};

export default ServicesList;
